import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';

import { assets } from '../../assets/';

const useStyles = makeStyles({});

export default function PercentageSlider() {
  const classes = useStyles();

  const MySlider = withStyles({
    root: {
      color: '#F87733',
    },
    active: {},
  })(Slider);

  return (
    <div>
      <Typography
        id="percentage-start-label-slider"
        color="inherit"
        variant="caption"
      >
        <img
          src={assets.icons.doughnutIcon}
          alt="allocated percentage"
          style={{
            maxHeight: 16,
            marginRight: 5,
          }}
        />
        Part à couvrir (%)
      </Typography>
      <Grid container spacing={2}>
        <Grid item>
          <Typography
            id="pricerange-start-label-slider"
            color="inherit"
            variant="caption"
          >
            0%
          </Typography>
        </Grid>
        <Grid item xs>
          <div className={classes.root} style={{ width: 300 }}>
            <MySlider
              aria-label="percentage-slider"
              defaultValue={60}
              valueLabelDisplay="auto"
            />
          </div>
        </Grid>
        <Grid item>
          <Typography
            id="percentage-end-label-slider"
            color="inherit"
            variant="caption"
          >
            100%
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/commons/PercentageSlider.js